<template>
  <Tooltip>
    <template #element>
      <span>
        Enddatum auswählen
      </span>
      <InformationCircleIcon class="info-icon" />
    </template>
    <template #content>
      <span>
        Markiert den Zeitpunkt der finalen Performance-Auswertung des Podcasts nach Anwendung der Methode. Wähle einen Zeitraum, in dem du Zeit für die Umsetzung hattest, als auch nennenswerte Ergebnisse erzielen konntest
      </span>
    </template>
  </Tooltip>
</template>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
